import Vue from "@src/libraries/vue";
import LoginButtons from "@src/components/LoginButtons.vue";
import logoSVG from "@src/assets/images/logo.svg";
import store from "@src/store";
export default Vue.extend({
    name: "Login",
    components: {
        LoginButtons,
    },
    data() {
        const data = {
            loginDialog: store.loginDialog,
            logoBackground: `background-image:url('${logoSVG}')`,
        };
        return data;
    },
    computed: {},
    methods: {
        hide() {
            const loginDialog = store.loginDialog;
            if (loginDialog)
                loginDialog.model = false;
        },
    },
});
